import Store from './store';

const lsStore = Store({
    advancedFilters: null,
    customAttributes: null,
    selectedLabels: null,
    selectedTeamMember: null,
}, 'advanced_filters');

export function setCustomAttributes (value = null) {
    lsStore.commit('save', {
        key: 'customAttributes',
        value: value,
    });
}

export function getCustomAttributes () {
    return lsStore.state.customAttributes;
}

export function setSelectedLabel (value = null) {
    lsStore.commit('save', {
        key: 'selectedLabels',
        value: value,
    });
}

export function getSelectedLabel () {
    return lsStore.state.selectedLabels;
}

export function setSelectedTeamMember (value = null) {
    lsStore.commit('save', {
        key: 'selectedTeamMember',
        value: value,
    });
}

export function getSelectedTeamMember () {
    return lsStore.state.selectedTeamMember;
}

export function setAdvancedFilters (value = null) {
    lsStore.commit('save', {
        key: 'advancedFilters',
        value: value,
    });
}

export function getAdvancedFilters () {
    return lsStore.state.advancedFilters;
}

